import script from "./HorizontalThresholdBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./HorizontalThresholdBarChart.vue?vue&type=script&lang=ts&setup=true"

import "./HorizontalThresholdBarChart.vue?vue&type=style&index=0&id=4688722d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4688722d"]])

export default __exports__